import script from "./FAQCell.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQCell.vue?vue&type=script&setup=true&lang=js"

import "./FAQCell.vue?vue&type=style&index=0&id=920c034a&lang=scss"

const __exports__ = script;

export default __exports__